import { PRESUPUESTADOR_SET_ERROR_AMOUNT } from '../constants'

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_ERROR_AMOUNT) {
        return {
            ...state,
            errorAmount: action.data
        }
    } else {
        return state
    }
}
